import { queryOptions } from "@tanstack/react-query";

import { api } from "@/api/api";
import type { FindApplicationSettingsOutputDto } from "@/types/codegen";
import { toTitleCase } from "@/utils/titleCase";

export const applicationSettingsQueryOptions = () =>
  queryOptions({
    queryKey: ["configuration"],
    queryFn: ({ signal }) =>
      api
        .get<FindApplicationSettingsOutputDto>("/configuration", {
          signal,
        })
        .then((response) => {
          const recommendedCities =
            response.data.data.flightSearch.recommendedCities.map((city) => ({
              ...city,
              // IRIX returns city names in uppercase, so we need to convert them to title case
              name: toTitleCase(city.name),
              type: "CITY" as const, // this is only needed for type errors, this value already has "CITY" type but generated types are set to 'string'
            }));

          const flightDefaultOrigin =
            response.data.data.flightSearch.defaultOrigin;

          const hotelDefaultDestination =
            response.data.data.hotelSearch.defaultDestination;

          return {
            ...response.data.data,
            flightSearch: {
              ...response.data.data.flightSearch,
              defaultOrigin: flightDefaultOrigin
                ? {
                    ...flightDefaultOrigin,
                    name: toTitleCase(flightDefaultOrigin.name),
                    type: "CITY" as const, // this is only needed for type errors, this value already has "CITY" type but generated types are set to 'string'
                  }
                : null,
              recommendedCities,
            },
            hotelSearch: {
              defaultDestination: hotelDefaultDestination
                ? {
                    ...hotelDefaultDestination,
                    name: toTitleCase(hotelDefaultDestination.name),
                    type: "CITY" as const, // this is only needed for type errors, this value already has "CITY" type but generated types are set to 'string'
                  }
                : null,
            },
          };
        }),
    throwOnError: false,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });
